import { withTranslation } from "react-i18next";
import DefaultPrice from './DefaultPrice';

export default withTranslation()(DefaultPrice);